/**
 * Shared axios instance + CSRF interceptors.
 * Domain services must not create their own axios clients.
 */
import axios from 'axios'

const client = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Do not set Access-Control-Allow-Origin on requests — that is a response header.
// Sending it (especially with withCredentials) breaks third-party CORS and confuses proxies.

client.interceptors.request.use((config) => {
  const token = document.cookie
    .split(';')
    .find((cookie) => cookie.trim().startsWith('XSRF-TOKEN='))

  if (token) {
    config.headers = config.headers || {}
    config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token.split('=')[1])
  }
  return config
})

client.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Response Error:', error.config, error.response)
    return Promise.reject(error)
  }
)

export default client
